import { Menu } from '@shinetools/lumen-react'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FILTER_TYPE_META, FILTER_TYPE_ORDER } from '../../../constants/reviewEntriesFilterConfig'
import { ReviewEntriesFilterType } from '../../../enums/reviewEntriesFilterType'
import { FilterTypeMenuHeader, FilterTypeMenuItem, FilterTypeMenuPanel } from '../styles'

interface ReviewEntriesFilterTypeMenuProps {
  availableTypes: ReviewEntriesFilterType[]
  onSelect: (type: ReviewEntriesFilterType) => void
  trigger: ReactElement
}

export const ReviewEntriesFilterTypeMenu = ({
  availableTypes,
  onSelect,
  trigger,
}: ReviewEntriesFilterTypeMenuProps): ReactElement => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const handleSelect = (type: ReviewEntriesFilterType) => {
    onSelect(type)
    setIsOpen(false)
  }

  return (
    <Menu onOpenChange={setIsOpen} open={isOpen} placement="bottom-end" size="small" trigger={trigger}>
      <FilterTypeMenuPanel>
        <FilterTypeMenuHeader>{t('review_entries.filters.type_picker.title')}</FilterTypeMenuHeader>
        {FILTER_TYPE_ORDER.filter((type) => availableTypes.includes(type)).map((type) => (
          <FilterTypeMenuItem key={type} onClick={() => handleSelect(type)} type="button">
            {t(FILTER_TYPE_META[type].labelKey)}
          </FilterTypeMenuItem>
        ))}
      </FilterTypeMenuPanel>
    </Menu>
  )
}
